module.exports = __webpack_public_path__ + "static/img/500.66bea9a4.png";